import * as React from 'react'

import { Box, Chevron, Text, Touchable } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

interface Props {
  currentPosition: number
  setCurrentPosition: (value: number) => void
  lastPosition: number
  currentDate: number
}

const Navigator = ({ currentPosition, setCurrentPosition, lastPosition, currentDate }: Props) => {
  const enablePrevious = currentPosition !== 0
  const enableNext = currentPosition !== lastPosition
  const onPrev = () => setCurrentPosition(currentPosition - 1)
  const onNext = () => setCurrentPosition(currentPosition + 1)
  const date = moment.unix(currentDate).format('ll')

  return (
    <Box alignItems="center" flexDirection="row">
      <Touchable onClick={onPrev} disabled={!enablePrevious}>
        <Chevron type={enablePrevious ? 'primary' : 'terciary'} direction="left" size="big" />
      </Touchable>
      <Touchable onClick={onNext} disabled={!enableNext}>
        <Chevron type={enableNext ? 'primary' : 'terciary'} direction="right" size="big" />
      </Touchable>
      <Text.Normal weight="medium">{date} </Text.Normal>
    </Box>
  )
}

export default observer(Navigator)
